// Reads the "Maximum Number of Trades Simultaneously" the client saved when they
// engaged (tbl_engagement.maxSimultaneous). Kept apart from index.jsx so the read's
// states can be tested without React: savedMaxSimultaneous.test.mjs.

/** Highest whole-number maxSimultaneous on the active rows, or null when none carries one. */
export function maxSimultaneousFromRows(rows) {
  const values = rows
    .filter((e) => e && e.status === 'active')
    .map((e) => Number(e.maxSimultaneous))
    .filter((n) => Number.isInteger(n) && n >= 1);
  return values.length ? Math.max(...values) : null;
}

/**
 * Starts one read. Reports { value, status } through onChange: 'loading' at once,
 * then 'ok' or 'error'. Returns a cancel function; a read that lands after cancel
 * reports nothing, so a previous user's rows can never reach the card.
 */
export function readSavedMaxSimultaneous(loadRows, onChange) {
  let cancelled = false;
  onChange({ value: null, status: 'loading' });
  Promise.resolve()
    .then(loadRows)
    .then((rows) => {
      if (!cancelled) onChange({ value: maxSimultaneousFromRows(rows), status: 'ok' });
    })
    .catch((e) => {
      console.warn('Could not read saved maxSimultaneous:', e);
      if (!cancelled) onChange({ value: null, status: 'error' });
    });
  return () => {
    cancelled = true;
  };
}
